import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spin, Switch, Tooltip, Icon } from 'antd';
import Map from './Map';
import Table from './Table';
import ProjectTable from './ProjectTable';
import Filter from './Filter';
import ProjectChart from '../../projectIndicatorAnalysis/components/AdaptChart';
import FinanceChart from '../../FinanceIndicatorAnalysis/components/AdaptChart';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';
import ExportUtil from '../../../../common/ExportUtil';
import { getMatchOption } from '../../../shared/selectFn';
import deepEqual from '../../../shared/deepEqual';
import { Indicator } from '../../constants/dimension';

const Url = {
    project: API_URL.dashboard.queryStatisticReportData,
    finance: API_URL.dashboard.queryGraphByType,
    person: API_URL.dashboard.queryEmployeeAnalysisGraph,
};
const DefaultPagination = {
    current: 1,
    pageSize: 10
};
const TableType = {
    SITE: 'centerIncome',
    PROJECT: 'financeIncome'
};

class Content extends Component {
    static contextTypes = {
        systemDate: PropTypes.object,
    }

    constructor(props, context) {
        super(props);

        this.indicator = this.getIndicator();
        this.renderList = this.getRenderList();
        let pageSize = 10;
        if (props.params.moduleType === 'CnyCurrentMonthIncomeNoTaxByPerson') {
            pageSize = 9;
        } else if (
            props.params.moduleType === 'MonthNewContractNum'
        ) {
            pageSize = 8;
        } else if (props.params.moduleType === 'MonthWorkInAdvanceNum') {
            pageSize = 6;
        } else if(props.params.moduleType === 'CnyCurrentMonthIncomeNoTax' && (props.params.analysisDimension === 'PROJECT_AREA' || props.params.analysisDimension === 'DISEASE' || props.params.analysisDimension === 'PROJECT' )){
            pageSize = 9;
        }
        this.state = {
            loading: false,
            searchParams: this.getSearchParams(props, {}, context),
            data: {},
            pagination: {...DefaultPagination, pageSize},
            showLegend: true,
            type: this.getType(),
            refresh: null,
            isTwoSpecialTable: false,
        };
    }

    componentDidMount() {
        if (this.isProjectTable()) {
            this.projectTableRef.loadData();
        } else {
            this.loadData();
        }
    }

    componentDidUpdate(prevProps) {
        const { params: prevParams } = prevProps; 
        const { params } = this.props;
        const {
            analysisDimension,
            moduleType,
        } = params;
        if (prevParams !== params) {
            this.indicator = this.getIndicator();
            this.renderList = this.getRenderList();
            const type = this.getType();
            const searchParams = this.getSearchParams(this.props, { type }, this.context);
            let pageSize = 10;
            if (params.moduleType === 'CnyCurrentMonthIncomeNoTaxByPerson') {
                pageSize = 9;
            } else if (
                params.moduleType === 'MonthNewContractNum'
            ) {
                pageSize = 8;
            } else if (params.moduleType === 'MonthWorkInAdvanceNum') {
                pageSize = 6;
            } else if(params.moduleType === 'CnyCurrentMonthIncomeNoTax' && (analysisDimension === 'PROJECT_AREA' || analysisDimension === 'DISEASE' || analysisDimension === 'PROJECT' )){
                pageSize = 9;
            }
            const isTwoSpecialTable = this.indicator.source === 'finance' && (analysisDimension === "HOSPITAL" || analysisDimension === "DEPARTMENT") && (moduleType === "CnyCurrentMonthIncomeNoTax" || moduleType === "CnyCurrentMonthIncomeNoTaxByPerson"); 
            this.setState({
                type,
                searchParams,
                pagination: {...DefaultPagination, pageSize},
                isTwoSpecialTable,
            }, () => {
                if (this.isProjectTable()) {
                    this.projectTableRef.loadData();
                } else if (type !== 'map') {
                    // finance 场景：数据加载由 Filter 在搜索条件完备后统一触发，避免 leader 未就绪时提前查询
                    if (this.indicator.source !== 'finance') {
                        this.loadData();
                    }
                }
            });
        }
    }

    loadData = (directSearchParams) => {
        const requestId = Date.now(); // 标记本次请求，防止竞态
        this.lastRequestId = requestId;

        const { params } = this.props;
        const { searchParams: stateSearchParams, isTwoSpecialTable } = this.state;
        // 如果有直接传入的 searchParams（来自 autoFillLeader），优先使用，避免时序竞争
        const searchParams = directSearchParams || stateSearchParams;
        const { analysisDimension } = params;

        this.setState({ loading: true });
        const originParams = {
            ...params,
            ...searchParams,
        };
        const { investigationMedicineType = [] } = searchParams;
        Fetch.post(
            Url[this.indicator.source],
            {
                ...originParams,
                groupType : this.indicator.source === "person" ? originParams.analysisDimension : null ,
                investigationMedicineType: investigationMedicineType[0],
                secondResearchProductType: investigationMedicineType[1],
                analysisDimension: isTwoSpecialTable ? `${analysisDimension}_COURTYARDAREA` : analysisDimension,
            }
        )
        .then(res => {
            // 如果不是最新发起的请求，直接丢弃结果
            if (this.lastRequestId !== requestId) return;

            const { params } = this.props;
            const { searchParams } = this.state;
            // 对比前后参数是否一致，防止参数变了，但是因为响应时间长，响应数据是之前请求的
            if (!deepEqual(originParams, { ...params, ...searchParams})) {
                this.setState({ loading: false });
            } else {
                this.setState({
                    data: res,
                    loading: false
                });
            }
        }).catch(err => {
            console.log(err);
            if (this.lastRequestId === requestId) {
                this.setState({ loading: false });
            }
        });
    }

    handleTableChange = ({ pagination }) => {
        this.setState({ pagination: {...pagination} });
    }

    handleExport = () => {
        const { params } = this.props;
        const { searchParams, isTwoSpecialTable } = this.state;
        const { analysisDimension } = params;
        const { investigationMedicineType = [] } = searchParams;
        if (this.indicator.source === "finance") {
            ExportUtil.export({
                ...params,
                ...searchParams,
                investigationMedicineType: investigationMedicineType[0],
                secondResearchProductType: investigationMedicineType[1],
                tableType: TableType[params.statisticalRange],
                analysisDimension: isTwoSpecialTable ? `${analysisDimension}_COURTYARDAREA` : analysisDimension,
            }, null, API_URL.dashboard.exportGraphByType)
        }
        if (this.indicator.source === "project") {
            ExportUtil.export({
                ...params,
                ...searchParams,
                investigationMedicineType: investigationMedicineType[0],
                secondResearchProductType: investigationMedicineType[1],
            }, null, API_URL.dashboard.exportStatisticReportData)
        }
        if (this.indicator.source === "person") {
            ExportUtil.export({
                ...params,
                ...searchParams,
                investigationMedicineType: investigationMedicineType[0],
                secondResearchProductType: investigationMedicineType[1],
                groupType:params.analysisDimension
            }, null, API_URL.dashboard.exportEmployeeAnalysisDetail)
        }
    }

    handleSearch = (directSearchParams) => {
        const { type } = this.state;
        if (this.isProjectTable()) {
            this.projectTableRef.loadData();
        } else if (type !== 'map') {
            this.loadData(directSearchParams);
            return;
        } else {
            this.setState({ refresh: {} });
        }
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams });
    }

    toggle = (e) => {
        const { systemDate: { trueYear, monthDate } } = this.context;
        const { type: prevType, searchParams, pagination } = this.state;
        const type = e.target.dataset.type;
        // 创建全新副本，禁止原地修改 state 对象
        const newSearchParams = { ...searchParams };
        const newPagination = { ...pagination };
        if (type === 'map') {
            newSearchParams.year = monthDate;
        } else if (type === 'table') {
            newPagination.current = 1;
        }
        if (prevType === 'map') {
            newSearchParams.year = trueYear;
        }
        this.setState({
            type,
            pagination: newPagination,
            searchParams: newSearchParams,
        }, () => {
            if (prevType === 'map') {
                if (this.isProjectTable()) {
                    this.projectTableRef.loadData();
                } else {
                    this.loadData();
                }
            }
            if (prevType === 'chart') {
                if (this.isProjectTable()) {
                    this.projectTableRef.loadData();
                }
            }
        });
    }

    handleSwitch = (checked) => {
        this.setState({ showLegend: checked });
    }

    getSearchParams = (props, state, context) => {
        const { systemDate: { trueYear, monthDate } } = context;
        const { params } = props;
        const { type } = state;
        const { analysisDimension, moduleType } = params;
        const searchParams = { year: (type === 'map' ? monthDate: trueYear) || params.year, investigationMedicineType: [] };
        if (
            (this.indicator.source === "finance" &&
            (
                analysisDimension === 'GLOBAL' ||
                analysisDimension === 'PROJECT_AREA' ||
                analysisDimension === 'DISEASE' ||
                analysisDimension === 'PROJECT'
            )) ||
            (this.indicator.source === "person" &&
            (
                analysisDimension === 'GLOBAL' ||
                analysisDimension === 'AREA' ||
                analysisDimension === 'CITY' ||
                analysisDimension === 'PROJECT_AREA'
            ))
        ) {
            searchParams.displayType = 'Difference';
        }
        if( (this.indicator.source === "project" &&
        (
            analysisDimension === 'GLOBAL' ||
            analysisDimension === 'PROJECT_AREA' ||
            analysisDimension === 'DISEASE' ||
            analysisDimension === 'SICKNESS' ||
            analysisDimension === 'PROJECT'
        ))){
            searchParams.displayType = 'All';
        }
        // bug-35065
        if(this.indicator.source === "project") {
            searchParams.leaderUserId = undefined;
            searchParams.leaderUserName = undefined;
        }
        if (this.indicator.source === "project" && moduleType === "INV_PLAN_FTE_PROGRESS_DIFF_GRAPH") {
            searchParams.displayType = 'Difference';
        }
        // 从当前 state.searchParams 中继承 finance 场景下领域leader的值，避免切换维度时丢失
        if (this.indicator.source === 'finance') {
            const currentSearchParams = this.state && this.state.searchParams;
            if (currentSearchParams && currentSearchParams.talUserId) {
                searchParams.talUserId = currentSearchParams.talUserId;
                searchParams.talUserName = currentSearchParams.talUserName;
            }
        }
        return searchParams;
    }

    isProjectTable = () => {
        return this.state.type === "table" && this.indicator.source === "project";
    }

    getIndicator = () => {
        const { params } = this.props;
        return getMatchOption(Indicator, 'moduleType', params.moduleType);
    }
    
    getRenderList = () => {
        const { params: { statisticalRange, analysisDimension } = {} } = this.props;
        const dimension = this.indicator.layer ? (this.indicator.layer || {})[statisticalRange].dimension || {} : this.indicator.dimension;
        return dimension[analysisDimension] || [];
    }

    getType = () => {
        return this.renderList[0].type;
    }

    getContent = () => {
        const { params } = this.props;
        const { searchParams, data, pagination, showLegend, type, refresh, isTwoSpecialTable } = this.state;
        const { title, source } = this.indicator;
        switch (source) {
            case 'project': {
                switch (type) {
                    case 'chart': {
                        const { chartTypes, dataType } = getMatchOption(this.renderList, 'type', type)
                        return (
                            <ProjectChart
                                data={data}
                                filename={title}
                                dataType={dataType}
                                showLegend={showLegend}
                                chartTypes={chartTypes}
                            />
                        );
                    }
                    case 'table': {
                        return (
                            <ProjectTable 
                                data={data}
                                params={{...params, ...searchParams}}
                                ref={el => { this.projectTableRef = el; }}
                            />
                        );
                    }
                    case 'map': {
                        return (
                            <Map
                                params={params}
                                searchParams={searchParams}
                                refresh={refresh}
                                source={source}
                            />
                        );
                    }
                    default:
                        return null;
                }
            }
            case 'finance': {
                switch (type) {
                    case 'chart': {
                        const config = getMatchOption(this.renderList, 'type', type);
                        return (
                            <FinanceChart
                                {...config}
                                data={data}
                                filename={title}
                                showLegend={showLegend}
                            />
                        );
                    }
                    case 'table': {
                        return (
                            <Table
                                data={data}
                                source={source}
                                pagination={pagination}
                                params={{...params, ...searchParams}}
                                onChange={this.handleTableChange}
                                isTwoSpecialTable={isTwoSpecialTable}
                            />
                        );
                    }
                    case 'map': {
                        return (
                            <Map
                                params={params}
                                searchParams={searchParams}
                                refresh={refresh}
                                source={source}
                            />
                        );
                    }
                    default:
                        return null;
                }
            }
            case 'person': {
                switch (type) {
                    case 'table': {
                        return (
                            <Table
                                data={data}
                                source={source}
                                pagination={pagination}
                                params={{...params, ...searchParams}}
                                onChange={this.handleTableChange}
                            />
                        );
                    }
                    default:
                        return null;
                }
            }
            default:
                return null;
        }
    }

    render() {
        const { params, params:{ statisticalRange } } = this.props;
        const { loading, searchParams, showLegend, type } = this.state;
        const { title, tips } = this.indicator;
        return (
            <div className="dsContent">
                <div className="outer">
                    <div className="chartHeader">
                        <div className="modTitle">
                            {title}
                            {
                                this.renderList.length > 1 &&
                                this.renderList
                                    .filter((item, index) => item.type !== type)
                                    .map(i => <i key={i.type} className="icon iconfont" data-type={i.type} onClick={this.toggle}>{i.icon}</i>)
                            }
                            {
                                type === 'chart' &&
                                <div className="legendContainer" style={{ display: 'inline-block', fontWeight: 'normal', color: '#999',marginLeft:"5px" }}>
                                    <Switch size="small" checked={showLegend} onChange={this.handleSwitch} />
                                    <span className="text">{!showLegend?"图例隐藏":"图例显示"}</span>
                                </div>
                            }
                        </div>
                        <Filter
                            type={type}
                            params={params}
                            searchParams={searchParams}
                            source={this.indicator.source}
                            onExport={this.handleExport}
                            onSearch={this.handleSearch}
                            onChange={this.handleChange}
                        />
                    </div>
                </div>
                {
                    statisticalRange == 'PROJECT' && tips && <p style={{ color: '#fd8760' }}>{tips}</p>
                }
                <Spin spinning={loading}>
                    <div style={{marginTop: 20}}>
                        {this.getContent()}
                    </div>
                </Spin>
            </div>
        );
    }
}

export default Content;


// WEBPACK FOOTER //
// ./src/components/homePage/DimensionAnalysis/components/Content.js